import styles from "./PurpleSection.module.css"

type SectionProps = {
  title: string
  description: string
}
const PurpleSection: React.FC<SectionProps> = ({ title, description }) => (
  <div className={styles.purpleContainer}>
    <div className={styles.text}>
      <h2>{title}</h2>
      <br />
      <h4>{description}</h4>
    </div>
  </div>
)
export default PurpleSection
